import useViewerStore from "@/stores/useViewerStore";
import { ClipboardList } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Toggle } from "../ui/toggle";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

const PropertyWindowButton = () => {
    const { propertiesPanelOpen, togglePropertiesPanel } = useViewerStore();
    const { t } = useTranslation();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <div>
                    <Toggle
                        aria-label={t("propertiesAriaLabel")}
                        className="mr-1"
                        pressed={propertiesPanelOpen}
                        onPressedChange={togglePropertiesPanel}
                    >
                        <ClipboardList className="h-4 w-4" />
                    </Toggle>
                </div>
            </TooltipTrigger>
            <TooltipContent>
                <p>{t("properties")}</p>
            </TooltipContent>
        </Tooltip>
    );
};
export default PropertyWindowButton;
